import classNames from "classnames";
import type { ReactNode } from "react";
import { flexStyles, heightStyles, paddingStyles, positionStyles, svgStyles } from "../../styles";
import { type Props as RawProps, RawTextInput } from "./RawTextInput";

interface Props extends RawProps {
  extra?: ReactNode;
}

export function RawTextInputWithExtra({ extra, className, ...props }: Props) {
  return (
    <div className={positionStyles.relative}>
      <div
        className={classNames(
          positionStyles.absolute,
          paddingStyles.ps100,
          heightStyles.full,
          flexStyles.horiz,
          flexStyles.alignCenter,
          svgStyles.neutral400,
        )}
      >
        {extra}
      </div>
      <RawTextInput className={classNames(paddingStyles.ps250, className)} {...props} />
    </div>
  );
}
